import { BaseEntity } from "./BaseEntity";
export enum UserRole {
  MENTOR = 'mentor',
  ADMIN = 'admin',
}
export interface User extends BaseEntity{
  name: string;
  email: string;
  password_hash: string;
  role: UserRole;
  phone?: string;
  address?: string | null;
  notifications?:boolean|false
  active: boolean;
  last_login?: string | null;
  receive_emails?:boolean;
}
export type NewUser = Omit<User, "id" | "created_at" | "updated_at">;
export interface UserToken{
  id:string;
  name:string;
  email:string;
  role:UserRole;
  phone:string;
  last_login?: string | null;
}
